// MATERIAL-UI
import { Collapse, Container, Grid } from "@mui/material";
// COMPONENTS
import Layout from "../components/core/Layout";
import MarketOptions from "../components/markets/Filter/MarketOptions";
import Filter from "../components/markets/Filter/Filter";
import MarketTable from "../components/markets/Table/MarketTable";
import MarketHeader from "../components/markets/Header/MarketHeader";
//Redux
import {
  setMarketType,
  toggleFilterOptions,
  useMarketsState,
} from "../store/features/markets.slice";
// ASSETS
import { MarketStyles } from "../components/markets/styles/Markets.styles";
import SearchBar from "../components/markets/Filter/searchbar/SearchBar";
import CardSection from "../components/markets/Cards/CardSection";
import MarketsDisclaimer from "../components/disclosures/MarketsDisclaimer";
import { trackEvent } from "src/Amplitude";
import { useEffect } from "react";
import AlertsTable from "src/components/markets/Table/AlertsTable";
import { useAppDispatch } from "src/store/store";

const LINKS = ["All", "Watchlist", "Portfolio", "Biggest gainers", "Recently added", "Alerts"];

const Markets = (): JSX.Element => {
  const classes = MarketStyles();

  //------------------------_REDUX---------------------------
  const { displayMarketHighlights, filterOption } = useMarketsState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // reset market type to All when page first renders
    if (filterOption !== "Alerts") {
      dispatch(setMarketType("All"));
      dispatch(toggleFilterOptions("All"));
      trackEvent("Visit_Page", { page: "Markets" });
    }
    //reset state when leaving
    return () => {
      dispatch(setMarketType("All"));
      dispatch(toggleFilterOptions("All"));
    };
  }, []);

  return (
    <Layout>
      <Container>
        <Grid container>
          <Grid item xs={12} className={classes.cardSection}>
            <MarketHeader />
          </Grid>
          <Grid
            item
            xs={12}
            className={classes.cardSection}
            sx={{ display: { sm: "block", xs: "none" } }}>
            <Collapse in={displayMarketHighlights}>
              <CardSection />
            </Collapse>
          </Grid>
          <Grid item xs={12} lg={5} mt={2}>
            <MarketOptions links={LINKS} />
          </Grid>
          <Grid container item xs={12} lg={7} mt={2}>
            <Grid item xs={12} sm={9} md={10} textAlign="end">
              {filterOption !== "Alerts" && <SearchBar />}
            </Grid>
            <Grid item xs={12} sm={3} md={2} textAlign="end">
              {filterOption !== "Alerts" && <Filter defaultValue="Sector" />}
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.marketTable}>
            {filterOption === "Alerts" ? <AlertsTable /> : <MarketTable />}
          </Grid>
          {/* UK-only general information disclaimer */}
          <Grid item xs={12}>
            <MarketsDisclaimer />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Markets;
